import {
  CircularProgress,
  FormControlLabel,
  Switch,
  Box,
  Typography,
  IconButton,
  Chip,
} from '@mui/material';
import Delete from '@mui/icons-material/Delete';
import Close from '@mui/icons-material/Close';
import Check from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import EventIcon from '@mui/icons-material/Event';
import { TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import React, { useState, useRef, useEffect } from 'react';
import MissionModal from '../Controls/MissionModal';
import { useParams } from 'react-router-dom';
import {
  getAllProcesses,
  deleteProcess,
  updateProcessDate,
  validateProcess,
} from '../../../../services/ProcessService';
import { updateStatusMission } from '../../../../services/MissionService';
import moment from 'moment';
import AppointmentModal from './Modals/CandidatProcess/AppointmentModal';
import SendCandidatToClientModal from './Modals/CandidatProcess/SendCandidatToClientModal';
import '../visuialisation.css';
import { withSnackbar } from '../../../../utils/SnackbarHOC';
import { Link } from 'react-router-dom';
import DialogDeleteCustom from '../../../../components/DialogDeleteCustom/DialogDeleteCustom';
import { addAppointment } from '../../../../services/AppointmentService';
import { removeLineBreak } from '../../../../utils/EditorUtil';
import { commonGridSx, gridLocaleText, makeGridToolbar } from '../../../../utils/gridStyles';
import {
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from '@mui/x-data-grid';
import { DataGrid } from '../../../../components/SortableDataGrid/SortableDataGrid';

const stepColors = {
  'Pré-selection': { bg: '#f0fdf4', color: '#16a34a', border: '#bbf7d0' },
  'Préqualif RH': { bg: '#eff6ff', color: '#2563eb', border: '#bfdbfe' },
  'ENVOI CLIENT': { bg: '#fff7ed', color: '#c2410c', border: '#fed7aa' },
  'RV CLIENT': { bg: '#fef3c7', color: '#92400e', border: '#fde68a' },
  'RV Closing': { bg: '#fef2f2', color: '#dc2626', border: '#fecaca' },
  'Embauche': { bg: '#f0fdf4', color: '#166534', border: '#86efac' },
  'Integration': { bg: '#ecfdf5', color: '#065f46', border: '#6ee7b7' },
  'Non validée': { bg: '#fef2f2', color: '#991b1b', border: '#fecaca' },
  'Refusé par client': { bg: '#fff1f2', color: '#9f1239', border: '#fda4af' },
  'Refusé par candidat': { bg: '#fff1f2', color: '#9f1239', border: '#fda4af' },
  'No show': { bg: '#f8fafc', color: '#64748b', border: '#e2e8f0' },
};

function getStepLabel(row) {
  const expectedStatus = [
    'Non validée', 'Embauche', 'Integration',
    'REFUSÉ PAR CLIENT', 'REFUSÉ PAR CANDIDAT',
    'Refusé par client', 'Refusé par candidat', 'Refusé par Go&Dev', 'No show',
  ];
  const { step, dateAccrochage, sent, rvClient, rvClosing } = row;
  if (expectedStatus.includes(step)) return step;
  if (rvClosing && rvClosing.date) return 'RV Closing';
  if (rvClient && rvClient.date) return 'RV CLIENT';
  if (sent && sent.date) return 'ENVOI CLIENT';
  if (dateAccrochage && dateAccrochage.date) return 'Préqualif RH';
  return 'Pré-selection';
}

// Date pickers inside grid cells: v7 accessible field (the v6 <input> field crashes when the
// cell re-renders: "reading selectionStart of null") and keystrokes kept away from the grid.
// The picker emits partial dates while typing: only save a full, valid date.
const isCompleteDate = (d) => d instanceof Date && !Number.isNaN(d.getTime()) && d.getFullYear() >= 1900;
const pickerSlotProps = { textField: { size: 'small', onKeyDown: (e) => e.stopPropagation() } };

function ProcessToolbar({ missionModalProps, missionPassive, setMissionPassive }) {
  return (
    <GridToolbarContainer sx={{ px: 1.5, py: 1, borderBottom: '1px solid #f1f5f9', display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
      <MissionModal {...missionModalProps} />
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, ml: 'auto' }}>
        <Typography sx={{ fontSize: '0.65rem', fontWeight: 700, color: '#03407b', letterSpacing: '0.09em', textTransform: 'uppercase' }}>
          Missions Passives
        </Typography>
        <FormControlLabel
          control={
            <Switch
              checked={missionPassive}
              onChange={(e) => setMissionPassive(e.target.checked)}
              sx={{
                '& .MuiSwitch-thumb': { backgroundColor: missionPassive ? '#03407b' : '#9ca3af' },
                '& .MuiSwitch-track': { backgroundColor: missionPassive ? '#7fb3d3' : '#d1d5db', opacity: 1 },
              }}
            />
          }
          label=""
          sx={{ ml: 0, mr: 0 }}
        />
      </Box>
      <GridToolbarQuickFilter
        quickFilterParser={(searchInput) => searchInput.split(',').map((value) => value.trim()).filter((value) => value !== '')}
        sx={{ '& .MuiInputBase-root': { background: '#f8fafc', borderRadius: '8px', fontSize: '1rem', px: 1, border: '1px solid #e2e8f0' }, '& .MuiOutlinedInput-notchedOutline': { border: 'none' } }}
      />
    </GridToolbarContainer>
  );
}

const Process = ({
  setAutresPieces,
  candidatName,
  candidatEmail,
  candidatTel,
  candidatAccountManager,
  candidatConsultant,
  candidatSeniorite,
  candidatCommentaire,
  candidatPointFort,
  candidatSoftskills,
  candidatFrancais,
  candidatAnglais,
  candidatActuPackage,
  candidatActuFixe,
  candidatActuVariable,
  candidatActuInteress,
  candidatSouhaitePackage,
  candidatsouhaiteFixe,
  candidatsouhaiteVariable,
  candidatsouhaiteInteress,
  candidatpreAvis,
  candidatdispoLe,
  numCandidat,
  snackbarShowMessage,
  processId,
  handleOpenModal,
  setMessageType,
  ...rest
}) => {
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const parametters = useParams();
  const idCandidat = rest.idCandidat ?? parametters.idCandidat;
  const [missionPassive, setMissionPassive] = useState(false);
  const [processes, setProcesses] = useState([]);
  const [loadingtoFinish, setLoadingToFinish] = useState(false);
  const [loadingToDelete, setLoadingToDelete] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const [missionInfos, setMissionInfos] = useState({ id: '', nom: '' });
  const [openFinishDialog, setOpenFinishDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const isActive = useRef();

  // Calendar state: processId or null
  const [showCalendar, setShowCalendar] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [showEmbacheCalendar, setShowEmbacheCalendar] = useState(null);
  const [selectedEmbacheDate, setSelectedEmbacheDate] = useState(null);
  const [showIntegrationCalendar, setShowIntegrationCalendar] = useState(null);
  const [selectedIntegrationDate, setSelectedIntegrationDate] = useState(null);
  // Date being edited in place: { pid, field } or null
  const [editingDate, setEditingDate] = useState(null);

  const handleCloseFinishDialog = () => { if (!loadingtoFinish) setOpenFinishDialog(false); };
  const handleCloseDeleteDialog = () => { if (!loadingToDelete) setOpenDeleteDialog(false); };

  const handleDeleteProcess = (row) => {
    setMissionInfos({ id: row.processId, nom: row.nom_mission });
    setOpenDeleteDialog(true);
  };

  const handleFinishMission = () => {
    if (!loadingtoFinish) {
      setLoadingToFinish(true);
      (async () => {
        try {
          const { data } = await updateStatusMission(missionInfos.id);
          if (!isActive.current) return;
          snackbarShowMessage(data);
          handleCloseFinishDialog();
          setReloadData(!reloadData);
        } catch (error) {
          if (!isActive.current) return;
          snackbarShowMessage(error.response?.data?.error?.detail, 'error', 4000);
        } finally {
          setLoadingToFinish(false);
        }
      })();
    }
  };

  const handleDateChange = async (processId, dateType, newDate) => {
    try { await updateProcessDate(processId, dateType, newDate); } catch {}
  };

  const handleDateSelection = async (date, row, dateType) => {
    if (!isCompleteDate(date)) return; // still typing / cleared
    setSelectedDate(date);
    const formattedDate = moment(date).format('YYYY-MM-DD');
    await handleDateChange(row.processId, dateType, formattedDate);
    setReloadData(!reloadData);
    setShowCalendar(null);
  };

  const handleEmbacheDateChange = async (date, prId) => {
    const formattedDate = moment(date).format('YYYY-MM-DD');
    try {
      setLoading(true);
      const payload = { date: formattedDate, status: 'Embauche', commentaire: removeLineBreak(''), dateIntegration: null, candidat: '', selected: [] };
      const response = await addAppointment(prId, payload);
      snackbarShowMessage(response.data);
    } catch (error) {
      snackbarShowMessage(error.response?.data?.error?.detail || 'Une erreur est survenue');
    } finally { setLoading(false); }
    setReloadData(!reloadData);
  };

  const handleEmbacheDateSelection = (date, row) => {
    if (!isCompleteDate(date)) return; // still typing / cleared
    setSelectedEmbacheDate(date);
    handleEmbacheDateChange(date, row.processId);
    setShowEmbacheCalendar(null);
  };

  const handleIntegrationDateChange = async (date, prId) => {
    const formattedDate = moment(date).format('YYYY-MM-DD');
    try {
      setLoading(true);
      const payload = { date: null, status: 'Integration', commentaire: removeLineBreak(''), dateIntegration: formattedDate, candidat: '', selected: [] };
      const response = await addAppointment(prId, payload);
      snackbarShowMessage(response.data);
    } catch (error) {
      snackbarShowMessage(error.response?.data?.error?.detail || 'Une erreur est survenue');
    } finally { setLoading(false); }
    setReloadData(!reloadData);
  };

  const handleIntegrationDateSelection = (date, row) => {
    if (!isCompleteDate(date)) return; // still typing / cleared
    setSelectedIntegrationDate(date);
    handleIntegrationDateChange(date, row.processId);
    setShowIntegrationCalendar(null);
  };

  // Edit an existing RV Client / RV Closing / Embauche / Intégration date, whatever the current step
  const handleDateEdit = async (date, row, field) => {
    if (!isCompleteDate(date)) return; // still typing / cleared
    try {
      setLoading(true);
      await updateProcessDate(row.processId, field, moment(date).format('YYYY-MM-DD'));
      snackbarShowMessage('Date modifiée avec succès.');
      setReloadData((r) => !r);
    } catch (error) {
      snackbarShowMessage(error.response?.data?.error?.detail || 'Une erreur est survenue', 'error', 4000);
    } finally {
      setLoading(false);
      setEditingDate(null);
    }
  };

  const renderEditableDate = (row, field, value, width = '170px') => {
    const pid = row.processId;
    // Values come as "YYYY-MM-DD" or "YYYY-MM-DD HH:mm:ss…": keep the calendar day only
    const m = moment(String(value).slice(0, 10), 'YYYY-MM-DD', true);
    if (editingDate?.pid !== pid || editingDate?.field !== field) {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <Typography sx={{ fontSize: '1rem', color: '#3b82f6' }}>{m.isValid() ? m.format('DD/MM/YYYY') : '—'}</Typography>
          <IconButton size="small" onClick={() => setEditingDate({ pid, field })}>
            <EditIcon sx={{ fontSize: 14 }} />
          </IconButton>
        </Box>
      );
    }
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <DatePicker
          enableAccessibleFieldDOMStructure
          slotProps={pickerSlotProps}
          value={m.isValid() ? m.toDate() : null}
          onChange={(date) => handleDateEdit(date, row, field)}
          format="dd-MM-yyyy" sx={{ width }}
        />
        <IconButton size="small" onClick={() => setEditingDate(null)}>
          <Close sx={{ fontSize: 14 }} />
        </IconButton>
      </Box>
    );
  };

  const deleteProcessFromCandidat = () => {
    (async () => {
      setLoadingToDelete(true);
      try {
        const deletedId = missionInfos.id;
        const { data } = await deleteProcess(deletedId);
        if (!isActive.current) return;
        snackbarShowMessage(typeof data === 'string' ? data : 'Le process a été supprimé avec succès.');
        // Remove the row right away, then reload from the server; other tabs are told to refresh.
        setProcesses((prev) => prev.filter((p) => p.processId !== deletedId));
        setCount((c) => Math.max(0, c - 1));
        setOpenDeleteDialog(false);
        setReloadData((r) => !r);
        window.dispatchEvent(new CustomEvent('candidat-process-changed', { detail: { processId: deletedId } }));
      } catch (error) {
        snackbarShowMessage(error.response?.data?.error?.detail, 'error', 4000);
      } finally { setLoadingToDelete(false); }
    })();
  };

  const handleValidateProcess = async (processID) => {
    try {
      snackbarShowMessage('Validation du process en cours...', 'warning');
      await validateProcess(processID);
      snackbarShowMessage('Process validé avec succès !');
      setReloadData(!reloadData);
    } catch (error) {
      snackbarShowMessage(error.response, 'error', 4000);
    }
  };

  const handleNotValidateProcess = async (processID) => {
    try {
      snackbarShowMessage("Non-validation du process en cours...", 'warning');
      const payload = { date: null, status: 'Non validée', commentaire: removeLineBreak(''), dateIntegration: null, candidat: '', selected: [] };
      await addAppointment(processID, payload);
      snackbarShowMessage('Process marqué comme non validé.');
    } catch (error) {
      snackbarShowMessage(error.response?.data?.error?.detail || 'Une erreur est survenue');
    }
    setReloadData(!reloadData);
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const status = missionPassive
          ? 'bad58bee-1b80-448c-9010-03cad8526233'
          : '910f357b-0b13-4f66-89a8-5c06964c1dcf';
        const res = await getAllProcesses(idCandidat, page, 50, status);
        setProcesses(res.data.processes);
        setCount(res.data.count);
      } catch (error) {
        snackbarShowMessage(error.response?.data?.error?.detail, 'error', 4000);
      } finally { setLoading(false); }
    })();
  }, [page, missionPassive, idCandidat, reloadData]);

  React.useEffect(() => {
    isActive.current = true;
    return () => { isActive.current = false; };
  });

  const columns = [
    {
      field: 'nom_societe', headerName: 'SOCIETE', width: 200,
      renderCell: (p) => (
        <Link to={`/societe/${p.row.societeId}/view`} style={{ textDecoration: 'none', color: '#03407b', fontSize: '1rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Link>
      ),
    },
    {
      field: 'statut', headerName: 'STATUT', width: 100,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value || '—'}</Typography>,
    },
    {
      field: 'nom_mission', headerName: 'MISSION', width: 200,
      renderCell: (p) => (
        <Link to={`/societe/${p.row.processId}/missions/${p.row.missionId}/view`} style={{ textDecoration: 'none', color: '#03407b', fontSize: '1rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Link>
      ),
    },
    {
      field: 'step', headerName: 'STEP', width: 160, valueGetter: (value, row) => getStepLabel(row),
      renderCell: (p) => {
        const label = getStepLabel(p.row);
        const cfg = stepColors[label] || { bg: '#f8fafc', color: '#475569', border: '#e2e8f0' };
        return (
          <Chip label={label} size="small"
            sx={{ background: cfg.bg, color: cfg.color, border: `1px solid ${cfg.border}`, fontWeight: 600, fontSize: '1rem', height: 22, borderRadius: '6px' }} />
        );
      },
    },
    {
      field: 'datePreSelection', headerName: 'PRÉ-SÉLECTION', width: 130,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#3b82f6' }}>
          {p.value?.date ? moment.utc(p.value.date).format('DD/MM/YYYY') : '—'}
        </Typography>
      ),
    },
    {
      field: '_selection', headerName: 'SELECTION', width: 100, sortable: false,
      renderCell: (p) => {
        const disabled = !!(p.row.dateAccrochage || p.row.step === 'Non validée');
        return (
          <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
            <IconButton size="small" onClick={() => handleNotValidateProcess(p.row.processId)}
              disabled={disabled} sx={{ color: disabled ? '#d1d5db' : '#ef4444', p: 0.5 }}>
              <Close sx={{ fontSize: 18 }} />
            </IconButton>
            <IconButton size="small" onClick={() => handleValidateProcess(p.row.processId)}
              disabled={disabled} sx={{ color: disabled ? '#d1d5db' : '#22c55e', p: 0.5 }}>
              <Check sx={{ fontSize: 18 }} />
            </IconButton>
          </Box>
        );
      },
    },
    {
      field: 'dateAccrochage', headerName: 'PRÉQUALIF RH', width: 160,
      renderCell: (p) => {
        const row = p.row;
        if (!p.value) return null;
        return (
          <Typography sx={{ fontSize: '1rem', color: '#3b82f6' }}>
            {moment.utc(p.value.date).format('DD/MM/YYYY')}
          </Typography>
        );
      },
    },
    {
      field: 'sent', headerName: 'ENVOI CLIENT', width: 180,
      renderCell: (p) => {
        const row = p.row;
        if (!row.dateAccrochage) return null;
        return (
          <SendCandidatToClientModal
            reloadData={reloadData} setReloadData={setReloadData}
            candidatName={candidatName} setAutresPieces={setAutresPieces}
            missions={processes} selectedMission={row.missionId}
            sentDate={p.value?.date ? moment(p.value.date).format('DD/MM/yyyy') : (['Refusé par candidat', 'Refusé par client', 'Refusé par Go&Dev'].includes(row.step) ? '' : 'Envoyer')}
            candidatAccountManager={candidatAccountManager} candidatConsultant={candidatConsultant}
            candidatSeniorite={candidatSeniorite} candidatCommentaire={candidatCommentaire}
            candidatPointFort={candidatPointFort} candidatSoftskills={candidatSoftskills}
            candidatFrancais={candidatFrancais} candidatAnglais={candidatAnglais}
            candidatActuPackage={candidatActuPackage} candidatActuFixe={candidatActuFixe}
            candidatActuVariable={candidatActuVariable} candidatActuInteress={candidatActuInteress}
            candidatSouhaitePackage={candidatSouhaitePackage} candidatsouhaiteFixe={candidatsouhaiteFixe}
            candidatsouhaiteVariable={candidatsouhaiteVariable} candidatsouhaiteInteress={candidatsouhaiteInteress}
            candidatpreAvis={candidatpreAvis} candidatdispoLe={candidatdispoLe} numCandidat={numCandidat}
            processId={processes.find((pr) => pr.missionId === row.missionId)?.processId}
            key={row.missionId}
            isMissionActive={row.statut === 'ACTIVE'}
            disabled={!!(p.value?.date || ['Refusé par candidat', 'Refusé par client', 'Refusé par Go&Dev'].includes(row.step))}
          />
        );
      },
    },
    {
      field: 'rvClient', headerName: 'RV CLIENT', width: 210,
      renderCell: (p) => {
        const row = p.row;
        if (!row.sent) return null;
        if (['Refusé par candidat', 'Refusé par client'].includes(row.step)) return null;
        const pid = row.processId;

        if (p.value?.date) return renderEditableDate(row, 'rvClient', p.value.date, '160px');

        return (
          <Box>
            {showCalendar !== pid && (
              <EventIcon sx={{ cursor: 'pointer', color: '#3b82f6', fontSize: 20 }} onClick={() => setShowCalendar(pid)} />
            )}
            {showCalendar === pid && (
              <DatePicker
                enableAccessibleFieldDOMStructure
                slotProps={pickerSlotProps}
                value={selectedDate}
                onChange={(date) => handleDateSelection(date, row, 'rvClient')}
                format="dd-MM-yyyy" sx={{ width: '160px' }}
              />
            )}
          </Box>
        );
      },
    },
    {
      field: 'rvClosing', headerName: 'RV CLOSING', width: 190,
      renderCell: (p) => {
        const row = p.row;
        if (!row.rvClient) return null;
        if (['Refusé par candidat', 'Refusé par client'].includes(row.step)) return null;
        const pid = row.processId;

        if (p.value?.date) return renderEditableDate(row, 'rvClosing', p.value.date);

        return (
          <Box>
            {showCalendar !== pid && (
              <EventIcon sx={{ cursor: 'pointer', color: '#3b82f6', fontSize: 20 }} onClick={() => setShowCalendar(pid)} />
            )}
            {showCalendar === pid && (
              <DatePicker
                enableAccessibleFieldDOMStructure
                slotProps={pickerSlotProps}
                value={selectedDate}
                onChange={(date) => handleDateSelection(date, row, 'rvClosing')}
                format="dd-MM-yyyy" sx={{ width: '170px' }}
              />
            )}
          </Box>
        );
      },
    },
    {
      field: 'dateEmbauche', headerName: 'EMBAUCHE', width: 190,
      renderCell: (p) => {
        const row = p.row;
        if (!row.rvClosing) return null;
        if (['Refusé par candidat', 'Refusé par client'].includes(row.step)) return null;
        const pid = row.processId;

        if (p.value) return renderEditableDate(row, 'dateEmbauche', p.value);

        return (
          <Box>
            {showEmbacheCalendar !== pid && (
              <EventIcon sx={{ cursor: 'pointer', color: '#3b82f6', fontSize: 20 }} onClick={() => setShowEmbacheCalendar(pid)} />
            )}
            {showEmbacheCalendar === pid && (
              <DatePicker
                enableAccessibleFieldDOMStructure
                slotProps={pickerSlotProps}
                value={selectedEmbacheDate}
                onChange={(date) => handleEmbacheDateSelection(date, row)}
                format="dd-MM-yyyy" sx={{ width: '170px' }}
              />
            )}
          </Box>
        );
      },
    },
    {
      field: 'dateIntegration', headerName: 'INTÉGRATION', width: 210,
      renderCell: (p) => {
        const row = p.row;
        if (!row.rvClosing) return null;
        if (['Refusé par candidat', 'Refusé par client'].includes(row.step)) return null;
        const pid = row.processId;

        const rawValue = p.value && typeof p.value === 'object' && p.value.date ? p.value.date : p.value;
        const hasValue = rawValue != null && rawValue !== 'null' && rawValue !== '';

        if (!hasValue) {
          return (
            <Box>
              {showIntegrationCalendar !== pid && (
                <EventIcon sx={{ cursor: 'pointer', color: '#3b82f6', fontSize: 20 }} onClick={() => setShowIntegrationCalendar(pid)} />
              )}
              {showIntegrationCalendar === pid && (
                <DatePicker
                enableAccessibleFieldDOMStructure
                slotProps={pickerSlotProps}
                  value={selectedIntegrationDate}
                  onChange={(date) => handleIntegrationDateSelection(date, row)}
                  format="dd-MM-yyyy" sx={{ width: '170px' }}
                />
              )}
            </Box>
          );
        }

        return renderEditableDate(row, 'dateIntegration', rawValue);
      },
    },
    {
      field: 'actions', headerName: 'ISSUE', width: 120, sortable: false,
      renderCell: (p) => {
        const row = p.row;
        const isPassive = row.statut === 'PASSIVE';
        return (
          <Box sx={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
            {(row.dateAccrochage || isPassive) && (
              <AppointmentModal
                reloadData={reloadData} setReloadData={setReloadData}
                processId={processes.find((pr) => pr.missionId === row.missionId)?.processId}
                missionId={typeof row.missionId === 'object' && row.missionId !== null
                  ? row.missionId?.uuid ?? row.missionId?.id ?? String(row.missionId)
                  : row.missionId}
                isPassive={isPassive}
                lastAppointment={row.rvClient}
                processStep={row.step}
                handleOpenModal={handleOpenModal}
                setMessageType={setMessageType}
              />
            )}
            {!isPassive && !row.sent && (
              <IconButton size="small" onClick={() => handleDeleteProcess(row)}
                sx={{ color: '#ef4444', background: '#fef2f2', borderRadius: '8px', '&:hover': { background: '#fee2e2' }, p: 0.75 }}>
                <Delete sx={{ fontSize: 16 }} />
              </IconButton>
            )}
          </Box>
        );
      },
    },
  ];

  const missionModalProps = { processes, setReloadData, reloadData, snackbarShowMessage };

  const rows = (processes || []).map((pr) => ({ ...pr, id: pr.processId }));

  return (
    <>
      <DialogDeleteCustom
        handleClose={handleCloseFinishDialog} open={openFinishDialog} handleConfirm={handleFinishMission}
        loading={loadingtoFinish} label={`Voulez vous vraiment achever la mission: ${missionInfos.nom}?`}
        title="Achever la mission"
      />
      <DialogDeleteCustom
        handleClose={handleCloseDeleteDialog} open={openDeleteDialog} handleConfirm={deleteProcessFromCandidat}
        loading={loadingToDelete} label={`Voulez vous supprimer le process: ${missionInfos.nom}?`}
        title="Supprimer le process?"
      />
      <Box sx={{ borderRadius: 3, border: '1px solid #e2e8f0', height: '44vh', minHeight: 300, background: '#fff', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.04)' }}>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row.id}
          loading={loading}
          paginationMode="server"
          rowCount={count}
          paginationModel={{ page: page - 1, pageSize: 50 }}
          onPaginationModelChange={(m) => setPage(m.page + 1)}
          pageSizeOptions={[50]}
          disableRowSelectionOnClick
          showToolbar
          slots={{ toolbar: ProcessToolbar }}
          slotProps={{
            toolbar: { missionModalProps, missionPassive, setMissionPassive },
            loadingOverlay: { variant: 'skeleton', noRowsVariant: 'skeleton' },
          }}
          localeText={gridLocaleText}
          sx={commonGridSx}
        />
      </Box>
    </>
  );
};

export default withSnackbar(Process);
